document.addEventListener("DOMContentLoaded", function () {
  const input = document.getElementById("post-search");
  const posts = document.querySelectorAll(".post-item");

  if (input) {
    input.addEventListener("input", function () {
      const keyword = this.value.toLowerCase();

      posts.forEach(post => {
        const title = post.getAttribute("data-title").toLowerCase();
        post.style.display = title.includes(keyword) ? "block" : "none";
      });
    });
  }
});